/**
 * クエリ条件文字列を先頭の「=」でキーと値に分ける（前後トリム）。URLエンコードは扱わない。
 * @param {string} query
 * @returns {{ key: string, value: string }}
 */
export function parseKeyValueFromQueryString(query) {
  const raw = (query || '').toString();
  const idx = raw.indexOf('=');
  if (idx === -1) {
    return { key: raw.trim(), value: '' };
  }
  return {
    key: raw.slice(0, idx).trim(),
    value: raw.slice(idx + 1).trim(),
  };
}

/**
 * API保存用の1セグメント（key=value）。値が空でも key= となる。
 * @param {string} key
 * @param {string} value
 * @returns {string}
 */
export function buildQueryStringFromKeyValue(key, value) {
  const k = (key || '').trim();
  const v = (value || '').trim();
  if (!k && !v) {
    return '';
  }
  return `${k}=${v}`;
}

/**
 * 複数行（1行1ペア）を & で結合したクエリ文字列にする。行内は先頭の = で key/value 分割。
 * @param {string} multiline
 * @returns {string}
 */
export function buildQueryParamFromMultiline(multiline) {
  const lines = (multiline || '')
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);
  const parts = [];
  lines.forEach((line) => {
    const idx = line.indexOf('=');
    if (idx === -1) {
      const k = line.trim();
      if (k) {
        parts.push(`${k}=`);
      }
      return;
    }
    const k = line.slice(0, idx).trim();
    const v = line.slice(idx + 1).trim();
    if (!k) {
      return;
    }
    parts.push(`${k}=${v}`);
  });
  return parts.join('&');
}

/**
 * 保存済みクエリ（& 区切り）をテキストエリア用の複数行に戻す。
 * @param {string} queryParam
 * @returns {string}
 */
export function multilineFromQueryParam(queryParam) {
  const raw = (queryParam || '').toString().trim();
  if (!raw) {
    return '';
  }
  return raw
    .split('&')
    .map((pair) => pair.trim())
    .filter((p) => p.length > 0)
    .join('\n');
}
